@if (!pagination()) {
  <div
    class="table-container"
    [style]="style()"
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="50"
    [scrollWindow]="false"
    (scrolled)="loadMoreItems()"
    infiniteScroll
    cdkScrollable
  >
    <!-- to do -->
    <table class="table">
      <thead class="table-header">
        @if (hasColumnGroups()) {
          <tr class="table-header-row">
            @if (selectable()) {
              <th class="table-header-cell">
                <div class="table-header-cell-content"></div>
              </th>
            }
            @for (column of columns(); track column) {
              @if (column.groupName) {
                <th
                  class="table-header-cell"
                  [class.persistent-filter-applied]="column.persistentFilterApplied"
                  [style]="{ minWidth: column.minWidth ?? undefined }"
                  [attr.colspan]="column.groupColSpan"
                  [attr.data-group]="column.groupName"
                >
                  @if (column.groupName) {
                    <div class="table-header-cell-content column-group">
                      @if (column.groupName) {
                        <span class="table-header-cell-text">{{ column.groupName | translate: { param: column.groupNameParam } }}</span>
                      }
                    </div>
                  }
                </th>
              }
            }
          </tr>
        }
        <tr class="table-header-row">
          @if (selectable()) {
            <th class="table-header-cell">
              <mat-checkbox [disabled]="!multipleSelect()" (change)="toggleSelectAll($event.checked)"></mat-checkbox>
            </th>
          }
          @for (column of columns(); track column) {
            <th
              class="table-header-cell"
              [style]="{ minWidth: column.minWidth ?? undefined }"
              [class.persistent-filter-applied]="column.persistentFilterApplied"
              [attr.data-group]="column?.groupName"
            >
              <div class="table-header-cell-content" [class.wrap-column-header-text]="column.wrapColumnHeaderText">
                <div class="table-header-cell-left">
                  <span class="table-header-cell-text">{{ column.name | translate: { param: column.nameParam } }}</span>
                  @if (column.sortable) {
                    <div>
                      <button
                        class="toggle-button"
                        [class.toggle-button-active]="sortActive(column.selector)"
                        (click)="toggleSort(column.selector)"
                      >
                        <span class="icon-{{ getSortIcon(column.selector) }}"></span>
                      </button>
                    </div>
                  }
                </div>
                @if (column.filterable) {
                  <div>
                    <app-filter-menu
                      [filterOptions]="getFilterOptions(column.selector)"
                      [mode]="mode()"
                      [filterType]="column.filterType ?? 'checkbox'"
                      [selectedFilters]="column.selector | selectedFilterOptions: mode() : serverFilters() : filters"
                      [selector]="column.selector"
                      (selectedFiltersChange)="filterArray(column.selector, $event)"
                    ></app-filter-menu>
                  </div>
                }
              </div>
            </th>
          }
        </tr>
      </thead>
      @if (!loading()) {
        <tbody class="table-body" data-testid="table-body" [cdkDropListAutoScrollStep]="15" (cdkDropListDropped)="drop($event)" cdkDropList cdkDropListLockAxis="y">
          @for (row of displayedRows; track row) {
            <tr
              class="table-body-row"
              data-testid="table-body-row"
              [cdkDragDisabled]="!isRowDragAndDropAllowed()"
              [cdkDragData]="row"
              [cdkDragStartDelay]="100"
              [class.table-body-row-clickable]="emitRowClick()"
              [class.table-body-row-draggable]="isRowDragAndDropAllowed()"
              (click)="rowClicked(row)"
              cdkDrag
            >
              @if (selectable()) {
                <td class="table-body-cell row-select-cell">
                  <mat-checkbox data-testid="table-row-select-checkbox" [checked]="isSelected(row, selectAll)" (change)="toggleSelect(row)"></mat-checkbox>
                </td>
              }
              @for (column of columns(); track column) {
                <td class="table-body-cell" [attr.data-group]="column?.groupName">
                  @if (column.row) {
                    <div class="table-cell-content">
                      {{ column.row(row) }}
                      @if (column.copyValue) {
                        <span class="icon icon-Copy table-copy-icon" (click)="copyToClipboard(column.copyValue(row), $event)"></span>
                      }
                    </div>
                  }
                  @if (column.component) {
                    <div>
                      <app-component-wrapper
                        [component]="column.component"
                        (componentInit)="column.componentInit($event, row)"
                      ></app-component-wrapper>
                    </div>
                  }
                </td>
              }
            </tr>
          }
        </tbody>
      }
      @if (!loading() && hasFooter() && rows.length !== 0) {
        <tfoot>
          <tr>
            <!--Placeholder if the table is selectable for the checkbox column-->
            @if (selectable()) {
              <td></td>
            }
            @for (column of columns(); track column) {
              <td class="table-footer-cell" [attr.data-group]="column?.groupName">
                @if (column.footerValue || column.footerFn) {
                  <div>
                    <span class="table-footer-cell-text" [innerHTML]="getFooterValue(column)"></span>
                  </div>
                }
              </td>
            }
          </tr>
        </tfoot>
      }
    </table>
    @if (loading()) {
      <div class="table-loading-spinner">
        <mat-spinner [diameter]="50"></mat-spinner>
      </div>
    }
    @if (!loading() && rows.length === 0) {
      <div class="table-no-items">
        <span>No items found</span>
      </div>
    }
  </div>
} @else {
  <div class="table-container" [hidden]="loading()" [style]="style()" [class.in-dialog]="isTableInsideDialog()">
    <!-- to do -->
    <table class="table">
      <thead class="table-header">
        @if (hasColumnGroups()) {
          <tr class="table-header-row">
            @if (selectable()) {
              <th class="table-header-cell">
                <div class="table-header-cell-content"></div>
              </th>
            }
            @for (column of columns(); track column) {
              @if (column.groupName) {
                <th
                  class="table-header-cell"
                  [class.persistent-filter-applied]="column.persistentFilterApplied"
                  [style]="{ minWidth: column.minWidth ?? undefined }"
                  [attr.colspan]="column.groupColSpan"
                  [attr.data-group]="column.groupName"
                >
                  @if (column.groupName) {
                    <div class="table-header-cell-content column-group">
                      @if (column.groupName) {
                        <span class="table-header-cell-text">{{ column.groupName | translate: { param: column.groupNameParam } }}</span>
                      }
                    </div>
                  }
                </th>
              }
            }
          </tr>
        }
        <tr class="table-header-row">
          @if (selectable()) {
            <th class="table-header-cell">
              <mat-checkbox
                [indeterminate]="indeterminateTableHead"
                [checked]="selectAll"
                [disabled]="!multipleSelect()"
                (change)="toggleSelectAll($event.checked)"
              ></mat-checkbox>
            </th>
          }
          @for (column of columns(); track column) {
            <th
              class="table-header-cell"
              [style]="{ minWidth: column.minWidth ?? undefined }"
              [class.persistent-filter-applied]="column.persistentFilterApplied"
              [attr.data-group]="column?.groupName"
            >
              <div class="table-header-cell-content" [class.wrap-column-header-text]="column.wrapColumnHeaderText">
                <div class="table-header-cell-left">
                  <span class="table-header-cell-text">{{ column.name | translate: { param: column.nameParam } }}</span>
                  @if (column.sortable) {
                    <div>
                      <button
                        class="toggle-button"
                        [class.toggle-button-active]="sortActive(column.selector)"
                        (click)="toggleSort(column.selector)"
                      >
                        <span class="icon-{{ getSortIcon(column.selector) }}"></span>
                      </button>
                    </div>
                  }
                </div>
                @if (column.filterable) {
                  <div>
                    <app-filter-menu
                      [filterOptions]="getFilterOptions(column.selector)"
                      [mode]="mode()"
                      [filterType]="column.filterType ?? 'checkbox'"
                      [selectedFilters]="column.selector | selectedFilterOptions: mode() : serverFilters() : filters"
                      [selector]="column.selector"
                      (selectedFiltersChange)="filterArray(column.selector, $event)"
                    ></app-filter-menu>
                  </div>
                }
              </div>
            </th>
          }
        </tr>
      </thead>
      <tbody class="table-body" data-testid="table-body" (cdkDropListDropped)="drop($event)" cdkDropList cdkDropListLockAxis="y">
        @for (row of rows; track row) {
          <tr
            class="table-body-row"
            data-testid="table-body-row"
            [cdkDragDisabled]="!isRowDragAndDropAllowed()"
            [cdkDragData]="row"
            [class.table-body-row-clickable]="emitRowClick()"
            [class.table-body-row-draggable]="isRowDragAndDropAllowed()"
            (click)="rowClicked(row)"
            cdkDrag
          >
            @if (selectable()) {
              <td class="table-body-cell row-select-cell">
                <mat-checkbox data-testid="table-row-select-checkbox" [checked]="isSelected(row, selectAll)" (change)="toggleSelect(row)"></mat-checkbox>
              </td>
            }
            @for (column of columns(); track column) {
              <td class="table-body-cell" [attr.data-group]="column?.groupName">
                @if (column.row) {
                  <div class="table-cell-content">
                    {{ column.row(row) }}
                    @if (column.copyValue) {
                      <span class="icon icon-Copy table-copy-icon" (click)="copyToClipboard(column.copyValue(row), $event)"></span>
                    }
                  </div>
                }
                @if (column.component) {
                  <div>
                    <app-component-wrapper
                      [component]="column.component"
                      (componentInit)="column.componentInit($event, row)"
                    ></app-component-wrapper>
                  </div>
                }
              </td>
            }
          </tr>
        }
      </tbody>
      @if (!loading() && hasFooter()) {
        <tfoot>
          <tr>
            <!--Placeholder if the table is selectable for the checkbox column-->
            @if (selectable()) {
              <td></td>
            }
            @for (column of columns(); track column) {
              <td class="table-footer-cell" [attr.data-group]="column?.groupName">
                @if (column.footerValue || column.footerFn) {
                  <div>
                    <span class="table-footer-cell-text" [innerHTML]="getFooterValue(column)"></span>
                  </div>
                }
              </td>
            }
          </tr>
        </tfoot>
      }
    </table>
    @if (!loading() && rows.length === 0) {
      <div class="table-no-items">
        <span>No items found</span>
      </div>
    }
  </div>
  @if (loading()) {
    <app-loading [loadingMode]="LoadingMode.TABLE" />
  }
}

@if (pagination()) {
  <div class="table-footer-container">
    <div class="table-footer">
      <div class="pagination">
        <div class="pagination-container">
          <span>{{ 'default.tableRowHint' | translate }}</span>
          <mat-select class="page-size-selector" [value]="pageSize" [disabled]="loading()" (selectionChange)="changePageSize($event.value)">
            @for (pageSize of pageSizeOptionsToDisplay(); track pageSize) {
              <mat-option [value]="pageSize">{{ pageSize }}</mat-option>
            }
          </mat-select>
        </div>
        <div class="pagination-container">
          <div class="table-footer-cell">{{ page | paginationRange: pageSize : totalSize }}</div>
          <span class="icon-Arrowhead-left page-btn" (click)="previousPage()"></span>
          <span class="icon-Arrowhead-right page-btn" (click)="nextPage()"></span>
        </div>
      </div>
    </div>
  </div>
}
